export const firebaseConfig = {
    apiKey: "AIzaSyC5NQnxuNq6eC2ApWK3lN7-TpBbqmg42iU",
    authDomain: "nanog-e3f80.firebaseapp.com",
    databaseURL: "https://nanog-e3f80-default-rtdb.firebaseio.com",
    projectId: "nanog-e3f80",
    storageBucket: "nanog-e3f80.appspot.com",
    messagingSenderId: "499222044325",
    appId: "1:499222044325:web:700c9217dcbc98ff65774c",
    measurementId: "G-X05F8QQWY7"
  };
  